import { PageHeader } from 'components/PageHeader';
import { getTrans } from 'modules/i18n';
import { Layout } from 'modules/minimal-ui-theme';
import { LanguageSwitcher } from 'modules/profile';

export const LanguageSettingsPage = () => (
  <Layout
    header={
      <PageHeader title={getTrans('languageSettingsPage.title')} withBackBtn />
    }
    childrenStyles={{ px: 0 }}
  >
    <LanguageSwitcher />
  </Layout>
);
